import React from 'react'
import { Cell } from 'fixed-data-table-2'

/**
 * @typedef {object} HeaderCellProps
 * @property {object} definition
 * @property {Function} onSortChange
 */
import { Icon } from '@adc/ui-core'
import classnames from 'classnames/bind'
import DataTableUtils from '../utils'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

const HeaderCell = props => {
  const sortColumn = () => {
    const { definition, onSortChange } = props
    const { colProps = {}, field = '', dataType } = definition
    // sort takes the full field name so we do not convert to `baseField` here
    onSortChange(field, !colProps.sortAscending, dataType)
  }

  const { definition } = props
  const { colProps = {}, field = '' } = definition
  const baseField = field.substring(field.lastIndexOf('.') + 1)
  const sortableField = DataTableUtils.isColumnSortable(definition)
  const sortArrow = DataTableUtils.isColumnSorted(definition) ? (
    <Icon name={!colProps.sortAscending ? 'caret down' : 'caret up'} />
  ) : null

  return (
    <Cell
      data-elm-id={`header_${baseField}`}
      onClick={sortableField ? sortColumn : null}
      className={cx('header', { sortable: sortableField })}
    >
      <div
        style={{ width: DataTableUtils.getCellInnerWidth(colProps) }}
        className={cx('text-truncate', 'extra-right-padding')}
      >
        {definition.title}
        {sortArrow}
      </div>
    </Cell>
  )
}

export default HeaderCell
